import domContentLoaded from "dom-content-loaded";

domContentLoaded(() => {
  //
  const $slider_floor = $(".js_floorslider");
  $slider_floor.slick({
    accessibility: true,
    dots: false,
    arrows: true,
    // fade: true,
    // prevArrow: '<button type="button" class="slick-prevbtn"></button>',
    // nextArrow: '<button type="button" class="slick-nextbtn"></button>',
    // autoplay: true,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    // centerMode: true,
    // slidesToShow: 1,
    // centerPadding: '380px',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          // arrows: false,
          // centerPadding: "10%",
        },
      },
    ],
  });

  // イベントの画像スライダー
  const $slider_event = $(".js-eventimageslider");
  $slider_event.slick({
    accessibility: false,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 6000,
    cssEase: "linear",
    pauseOnHover: false,
    slidesToShow: 3,
    // slidesToScroll: 1,
    centerMode: true,
    // centerPadding: "20%",
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          centerPadding: "10%",
        },
      },
    ],
  });

  // $slider_mv.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
  //   $slider_mv.find(".slick-slide").each((index, el) => {
  //     const $this = $(el),
  //       slickindex = $this.attr("data-slick-index");
  //     if (nextSlide == slick.slideCount - 1 && currentSlide == 0) {
  //       if (slickindex == "-1") {
  //         $this.addClass("is-active-next");
  //       } else {
  //         $this.removeClass("is-active-next");
  //       }
  //     } else if (nextSlide == 0) {
  //       if (slickindex == slick.slideCount) {
  //         $this.addClass("is-active-next");
  //       } else {
  //         $this.removeClass("is-active-next");
  //       }
  //     } else {
  //       $this.removeClass("is-active-next");
  //     }
  //   });
  // });
});

// // 重要なお知らせ
// const $important_infoslider = $('.js-important_info');
// $important_infoslider.slick({
// 	vertical: true,
// 	accessibility: true,
// 	dots: false,
// 	arrows: true,
// 	// prevArrow: '<button type="button" class="slick-prevbtn"></button>',
// 	// nextArrow: '<button type="button" class="slick-nextbtn"></button>',
// 	autoplay: true,
// 	autoplaySpeed: 2500,
// 	pauseOnHover: true,
// 	// centerMode: true,
// 	// slidesToShow: 1,
// 	// centerPadding: '500px',
// });

(() => {
  document.addEventListener("DOMContentLoaded", () => {
    scrollToFirstValidator();
  });
  // document.querySelector("form").addEventListener("submit", (event) => {
  //   scrollToFirstValidator();
  // });
  function scrollToFirstValidator() {
    const validatorElement = document.querySelector(".validator-result-0");
    if (validatorElement) {
      const parentElement = validatorElement.closest(".bl_formGroup");
      if (parentElement) {
        parentElement.scrollIntoView();
      }
    }
  }
})();
